import {gaConfig} from '@stencil/hotels-config';
// SELECTOR FNS
import {
  goSafePersuasionSelector,
  hotelInfoSelector,
} from '@stencil/hotels-details-reducer/src/selectors';
// REFACTOR
import detailsPageClickGaPush from '@stencil/hotels-utils/src/details-page-click-ga-push';
import {detailsNavigationIdsAndValues} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
// UTILS
// REFACTOR
import {scrollToEl} from '@stencil/hotels-utils/src/scroll-into-view-details';
// COLOR PALETTE
import {defaultTheme} from '@stencil/build-theme';
import React from 'react';
import {useSelector} from 'react-redux';
import PersuasionHoverText from '../../../../../../stories/components/hotels/SRP/PersuasionHoverText/PersuasionHoverText';
import TriggerAnchorText from '../../../../../components/TriggerActionText';
import GoSafeTagPersuasion from '../GoSafeTagPersuasion/GoSafeTagPersuasion';
// COMPONENTS
import GoStaysStamp from '../GoStaysStamp/GoStaysStamp';
import HotelAddressText from '../HotelAddressText';
import HotelName from '../HotelName';
import HotelRatingStars from '../HotelRatingStars';
// STYLES
import * as S from './HotelInfo.styles';

const {DetailsGAClickEventActions} = gaConfig;

const defaultCoupleFriendlyTagData = [
  {
    ic: 'tCoupleFriendly',
    pt: 'Couple Friendly',
    htd: {
      ic: 'tCoupleFriendly',
      h: 'Couple Friendly Hotels',
      ht: ['Local ID Accepted', 'Un-married couples allowed'],
      hec: {
        tc: defaultTheme.colors.goRed.base,
        bgc: defaultTheme.colors.goWhite.base,
      },
      hoc: {
        tc: defaultTheme.colors.downriver.base,
        bgc: defaultTheme.colors.goRed.light,
      },
    },
    ccd: {
      tc: defaultTheme.colors.goRed.base,
      bgc: defaultTheme.colors.goWhite.base,
    },
  },
];

export default function HotelInfo() {
  const {isCF, isGostay, gostaysHoverList, cfData} = useSelector(hotelInfoSelector);
  const goSafePersuasionData = useSelector(goSafePersuasionSelector);

  return (
    <div
    // itemProp="itemReviewed"
    >
      <S.CenterDiv>
        {!!isGostay && <GoStaysStamp gostaysHoverList={gostaysHoverList} />}
        <HotelRatingStars />

        {(goSafePersuasionData && goSafePersuasionData.length && (
          <GoSafeTagPersuasion data={goSafePersuasionData[0]} />
        )) ||
          null}
      </S.CenterDiv>

      <S.CenterDiv>
        <HotelName />

        {!!isCF && (
          <S.CoupleFriendlyTagContainer>
            <PersuasionHoverText
              data={cfData.length ? cfData : defaultCoupleFriendlyTagData}
              defaultIcon={'tCoupleFriendly'}
              type="Couple Friendly Persuasion"
              persuasionTitleStyles={{
                border: `1px solid ${defaultTheme.colors.goBrandOrange.base}`,
              }}
            />
          </S.CoupleFriendlyTagContainer>
        )}
      </S.CenterDiv>

      <S.CenterDiv>
        <TriggerAnchorText
          onClick={() => {
            detailsPageClickGaPush({
              eventAction: DetailsGAClickEventActions.addressClick,
            });
            scrollToEl(detailsNavigationIdsAndValues.location.id);
          }}
          styleProps={{
            display: 'flex',
            alignItems: 'center',
            width: '42vw',
          }}
        >
          <HotelAddressText />
        </TriggerAnchorText>
      </S.CenterDiv>
    </div>
  );
}
